import filter from 'lodash/filter';
import map from 'lodash/map';

import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

const getAdditionalTv = (state: TInitialState) => {
    const tvGroups = filter(state[EEntity.tv], group => (group.alias !== 'base'));
    return map(
        tvGroups,
        group => ({
            ...group,
            selectedCount: Object.values(group.items).reduce((cur, acc) => {
                cur += acc.quantity;
                return cur;
            }, 0),
            items: map(group.items, (tvItem, key) => ({ ...tvItem, isSelected: tvItem.quantity > 0, key: Number(key) })),
        }),
    );
};

export default getAdditionalTv;
